import { useEffect, type RefObject } from 'react';

/**
 * Keep pulling pages until the list actually overflows its container.
 *
 * An infinite list triggers on scroll, but a page that does not fill its
 * container cannot be scrolled at all — so without this the remaining pages
 * are unreachable. Bounded by `hasMore`: it stops as soon as there is
 * something to scroll, or nothing left to fetch.
 */
export function useFillViewport(
  ref: RefObject<HTMLElement | null>,
  hasMore: boolean | undefined,
  loading: boolean,
  load: () => void,
  /** Something that changes when a page lands, so the check re-runs. */
  loadedCount: number
) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore || loading) return;
    if (el.scrollHeight <= el.clientHeight) load();
  }, [ref, hasMore, loading, load, loadedCount]);
}
